import { Component } from '@angular/core';


@Component({
  selector: 'ff-mfa-expired',
  templateUrl: './mfa_expired.component.html',
  styleUrls: ['./mfa_expired.component.scss'],
})
export class MfaExpiredComponent {

  constructor(

  ) {}
}
